import { config } from './config'

/** When true, banner/advert content is loaded from core; otherwise from WordPress CMS. */
export const cmsUseNew = (): boolean => config.publicRuntimeConfig?.cmsUseNew === true
